export const SET_FEED = 'EVENT/SET_FEED'
export const SET_FEEDS = 'EVENT/SET_FEEDS'
